import React from "react";

export default function CustomerWarning(props) {

  return (
    <div className="div-center pt-20 pl-20 pr-20 text-center">
      {props.children}
      <span className="chat-user-name">{props.title}</span>
      <span className="chat-user-username">{props.subtitle}</span>
    </div>
  );
}